import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import './Question.styles.scss';
import './Question.styles.responsive.scss';

type QuestionProps = {
  title: string;
  currentQuestionNum: number;
  numOfQuestions: number;
  className?: string;
  description?: string;
  customQuestioLabel?: string;
};

const Question: React.FC<QuestionProps> = (props) => {
  const {
    children,
    title,
    currentQuestionNum,
    numOfQuestions,
    className,
    description,
    customQuestioLabel,
  } = props;

  const { t } = useTranslation();

  const classes = classNames('question', className);

  return (
    <div className={classes}>
      <p className="question__count">
        {customQuestioLabel ||
          t('questionWithNum', { currentQuestionNum, numOfQuestions })}
      </p>
      <div>
        <p className="title">{title}</p>
        {description && <p className="description">{description}</p>}
      </div>
      {children}
    </div>
  );
};

export default Question;
